import * as React from 'react';
import { PublicPageWrapper } from '../_pageWrappers/PublicPageWrapper';
import { PasswordResetPanel } from './_components/PasswordResetPanel';

export default function RequestPasswordSetupPage (): JSX.Element
{
    return (
        <PublicPageWrapper>

            <PasswordResetPanel
                header='Opret adgangskode'
                helpText='Indtast navnet på din organisation og din e-mail. Så sender vi dig vejledning i at oprette en adgangskode.'
                isSetup
            />

        </PublicPageWrapper>
    );
}